import { TFunction } from 'i18next';
import { match } from 'ts-pattern';
import { KpiFactboxBenchmarkPeriods, KpiFactboxBenchmarkTypes } from './types';

export const getCustomDashboardLink = (dbId: string) => {
  return `/dashboard/custom/${dbId}`;
};

export const getCustomDashboardPageLink = (dbId: string, pageId: string) => {
  return `/dashboard/custom/${dbId}/${pageId}`;
};

export const getDefaultKpiBenchmarkTitle = (
  benchmarkPeriod: KpiFactboxBenchmarkPeriods,
  benchmarkType: KpiFactboxBenchmarkTypes,
  t: TFunction
) => {
  return match({ benchmarkPeriod, benchmarkType })
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.PRIOR_PERIOD,
        benchmarkType: KpiFactboxBenchmarkTypes.VALUE,
      },
      () => t('common:benchmark.priorPeriodValue')
    )
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.PRIOR_PERIOD,
        benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
      },
      () => t('common:benchmark.priorPeriodDelta')
    )
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.PRIOR_PERIOD,
        benchmarkType: KpiFactboxBenchmarkTypes.DELTA_PERCENT,
      },
      () => t('common:benchmark.priorPeriodDeltaPercent')
    )
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
        benchmarkType: KpiFactboxBenchmarkTypes.VALUE,
      },
      () => t('common:benchmark.yearOnYearValue')
    )
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
        benchmarkType: KpiFactboxBenchmarkTypes.DELTA,
      },
      () => t('common:benchmark.yearOnYearDelta')
    )
    .with(
      {
        benchmarkPeriod: KpiFactboxBenchmarkPeriods.YEAR_ON_YEAR,
        benchmarkType: KpiFactboxBenchmarkTypes.DELTA_PERCENT,
      },
      () => t('common:benchmark.yearOnYearDeltaPercent')
    )
    .exhaustive();
};
